///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const InfoIcon = ({
  height,
  fill = "#343434",
  title = messages.info.defaultMessage,
  width,
  ...props
}) => (
  <svg
    aria-labelledby="info-icon"
    height={height}
    viewBox="0 0 16 16"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title id="info-icon">{title}</title>
    <path
      fill={fill}
      d="M7.33333333,4.66666667 L8.66666667,4.66666667 L8.66666667,6 L7.33333333,6 L7.33333333,4.66666667 Z M7.33333333,7.33333333 L8.66666667,7.33333333 L8.66666667,11.3333333 L7.33333333,11.3333333 L7.33333333,7.33333333 Z M8,1.33333333 C4.32,1.33333333 1.33333333,4.32 1.33333333,8 C1.33333333,11.68 4.32,14.6666667 8,14.6666667 C11.68,14.6666667 14.6666667,11.68 14.6666667,8 C14.6666667,4.32 11.68,1.33333333 8,1.33333333 Z M8,13.3333333 C5.06,13.3333333 2.66666667,10.94 2.66666667,8 C2.66666667,5.06 5.06,2.66666667 8,2.66666667 C10.94,2.66666667 13.3333333,5.06 13.3333333,8 C13.3333333,10.94 10.94,13.3333333 8,13.3333333 Z"
    />
  </svg>
);

export default InfoIcon;
